import { render, staticRenderFns } from "./PartnerRegistration.vue?vue&type=template&id=3a2f7393&scoped=true&"
import script from "./PartnerRegistration.vue?vue&type=script&lang=js&"
export * from "./PartnerRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PartnerRegistration.vue?vue&type=style&index=0&id=3a2f7393&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2f7393",
  null
  
)

export default component.exports